import {PaymentContract, Payment} from './index';

function mapCard(contract: PaymentContract.Card): Payment.CreditCard {
  return {
    last4: contract.last4,
    brand: contract.brand,
    expMonth: contract.exp_month,
    expYear: contract.exp_year,
  };
}

function mapPayment(contract: PaymentContract.Metadata): Payment.Metadata {
  const {customer, payment_info} = contract;
  return {
    customer: customer ?? undefined,
    info: payment_info
      ? {
          paymentMethod: payment_info.payment_type,
          card: payment_info.card ? mapCard(payment_info.card) : undefined,
        }
      : undefined,
  };
}

export const paymentMapper = {mapPayment};
